module.exports = __webpack_public_path__ + "static/media/news-mobo.4f03221a.png";